<clr-datagrid  class="string-history-table">

  <clr-dg-column [clrDgField]="'timestamp'" [style.min-width.px]="75">
    <ng-container >Timestamp</ng-container>
  </clr-dg-column>
  <clr-dg-column [clrDgField]="'value'" [style.min-width.px]="500">
    <ng-container >Value</ng-container>
  </clr-dg-column>

  <clr-dg-row *clrDgItems="let item of stringHistory; let i = index" [clrDgItem]="item">
    <clr-dg-cell [style.min-width.px]="75">{{item.timestamp | bmsdateformatpipe : 'yy-MM-dd HH:mm'}}</clr-dg-cell>
    <clr-dg-cell [style.min-width.px]="500">{{item.value}}</clr-dg-cell>
  </clr-dg-row>
  <clr-dg-footer>
    <clr-dg-pagination #pagination [clrDgPageSize]="10">
      <clr-dg-page-size [clrPageSizeOptions]="[10,20,50,100]">
        Values</clr-dg-page-size>
      {{pagination.firstItem + 1}} - {{pagination.lastItem + 1}} of {{pagination.totalItems}} values
    </clr-dg-pagination>
  </clr-dg-footer>
</clr-datagrid>
